module.exports = __webpack_public_path__ + "media/images/river/distressed-f3f0b3e601da5ea2ff4a6d4b66277b52.jpg";